export default function HowItWorksUseMock() {
  return (
    <div className="relative max-w-full overflow-hidden rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
      <p className="text-sm font-semibold text-gray-900">Create account</p>
      <div className="mt-3 space-y-2">
        <div className="flex h-8 items-center rounded-md border border-gray-200 bg-white px-2.5 text-sm text-gray-900">
          acme
        </div>
        <div className="relative h-8 rounded-md border border-gray-200 bg-white">
          <span className="absolute left-2.5 top-1.5 h-5 w-px animate-pulse bg-gray-800" aria-hidden="true" />
          <span className="pointer-events-none absolute left-6 top-5" aria-hidden="true">
            <svg width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M2 2L12 22L14 14L22 12L2 2Z" fill="white" stroke="black" strokeWidth="2" />
            </svg>
          </span>
        </div>
      </div>
    </div>
  );
}
